module.exports = __webpack_public_path__ + "static/img/knowledgeBanner.756424ff.png";